module.exports = __webpack_public_path__ + "img/AeroVanti-Club-Suite.326fdb1f.jpg";